import { Goodie } from '../models/benefits.interfaces';

export const SkyMiles: Goodie[] = [
  {
    name: '5 Miles Per Dollar',
    icon: {
      alt: '5 Miles Per Dollar',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
    }
  },
  {
    name: 'Miles that never expire',
    icon: {
      alt: 'Miles that never expire',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/half-way-miles.svg'
    }
  },
  {
    name: 'SkyMiles Deals on  1,000+ Destinations',
    icon: {
      alt: 'SkyMiles Deals on  1,000+ Destinations',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/flight-deals-globe.svg'
    }
  },
  {
    name: 'Miles on partner products',
    icon: {
      alt: 'Miles on partner products',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/partner-products.svg'
    }
  },
  {
    name: 'Miles On Partner Flights',
    icon: {
      alt: 'Miles On Partner Flights',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/partner-flights.svg'
    }
  },
  {
    name: 'Even More',
    icon: {
      alt: 'Even More Benefits',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
    },
    link: {
      label: 'View All Your Benefits',
      url: '/us/en/skymiles/medallion-program/medallion-benefits'
    }
  }
];

export const SilverMedallion: Goodie[] = [
  {
    name: '7 Miles Per Dollar',
    icon: {
      alt: '7 Miles Per Dollar',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
    }
  },
  {
    name: 'Upgrade 24hrs Prior to departure',
    icon: {
      alt: 'Upgrade 24hrs Prior to departure',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
    }
  },
  {
    name: 'Priority Boarding',
    icon: {
      alt: 'Priority Boarding',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/priority-boarding.svg'
    }
  },
  {
    name: 'Miles on partner products',
    icon: {
      alt: 'Miles on partner products',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/partner-products.svg'
    }
  },
  {
    name: 'SkyTeam Elite Status',
    icon: {
      alt: 'SkyTeam Elite Status',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/skyteam-elite.svg'
    }
  },
  {
    name: 'Even More',
    icon: {
      alt: 'Even More Benefits',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
    },
    link: {
      label: 'View All Your Benefits',
      url: '/us/en/skymiles/medallion-program/medallion-benefits'
    }
  }
];

export const GoldMedallion: Goodie[] = [
  {
    name: '8 Miles Per Dollar',
    icon: {
      alt: '8 Miles Per Dollar',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
    }
  },
  {
    name: 'Upgrade 72hrs Prior To Departure',
    icon: {
      alt: 'Upgrade 72hrs Prior To Departure',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
    }
  },
  {
    name: 'Sky Priority Boarding',
    icon: {
      alt: 'Sky Priority Boarding',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/sky-priority-boarding.svg'
    }
  },
  {
    name: 'Complementary Drink Vouchers',
    icon: {
      alt: 'Complementary Drink Vouchers',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/drink-voucher-benefits.svg'
    }
  },
  {
    name: '1,000 Bonus Miles With hertz',
    icon: {
      alt: '1,000 Bonus Miles With hertz',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/car-bonus.svg'
    }
  },
  {
    name: 'Even More',
    icon: {
      alt: 'Even More Benefits',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
    },
    link: {
      label: 'View All Your Benefits',
      url: '/us/en/skymiles/medallion-program/medallion-benefits'
    }
  }
];

export const PlatinumMedallion: Goodie[] = [
  {
    name: '8 Miles Per Dollar',
    icon: {
      alt: '8 Miles Per Dollar',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
    }
  },
  {
    name: 'Upgrade Shortly After Ticketing',
    icon: {
      alt: 'Upgrade Shortly After Ticketing',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
    }
  },
  {
    name: 'Sky Priority Boarding',
    icon: {
      alt: 'Sky Priority Boarding',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/sky-priority-boarding.svg'
    }
  },
  {
    name: 'Complementary Drink Vouchers',
    icon: {
      alt: 'Complementary Drink Vouchers',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/drink-voucher-benefits.svg'
    }
  },
  {
    name: 'President’s Circle Hertz Status',
    icon: {
      alt: 'President’s Circle Hertz Status',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/car-bonus.svg'
    }
  },
  {
    name: 'Even More',
    icon: {
      alt: 'Even More Benefits',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
    },
    link: {
      label: 'View All Your Benefits',
      url: '/us/en/skymiles/medallion-program/medallion-benefits'
    }
  }
];

export const DiamondMedallion: Goodie[] = [
  {
    name: '9 Miles Per Dollar',
    icon: {
      alt: '9 Miles Per Dollar',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
    }
  },
  {
    name: 'Upgrade Shortly After Ticketing',
    icon: {
      alt: 'Upgrade Shortly After Ticketing',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
    }
  },
  {
    name: 'Highest Priority Boarding',
    icon: {
      alt: 'Highest Priority Boarding',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/sky-priority-boarding.svg'
    }
  },
  {
    name: 'Complementary Drink Vouchers',
    icon: {
      alt: 'Complementary Drink Vouchers',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/drink-voucher-benefits.svg'
    }
  },
  {
    name: 'Complementary Clear Membership',
    icon: {
      alt: 'Complementary Clear Membership',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/clear-membership.svg'
    }
  },
  {
    name: 'Even More',
    icon: {
      alt: 'Even More Benefits',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
    },
    link: {
      label: 'View All Your Benefits',
      url: '/us/en/skymiles/medallion-program/medallion-benefits'
    }
  }
];

export const Delta360: Goodie[] = [
  {
    name: '9 Miles Per Dollar',
    icon: {
      alt: '9 Miles Per Dollar',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
    }
  },
  {
    name: 'Upgrade Shortly After Ticketing',
    icon: {
      alt: 'Upgrade Shortly After Ticketing',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
    }
  },
  {
    name: 'Highest Priority Boarding',
    icon: {
      alt: 'Highest Priority Boarding',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/sky-priority-boarding.svg'
    }
  },
  {
    name: 'Complementary Drink Vouchers',
    icon: {
      alt: 'Complementary Drink Vouchers',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/drink-voucher-benefits.svg'
    }
  },
  {
    name: 'Complementary Clear Membership',
    icon: {
      alt: 'Complementary Clear Membership',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/clear-membership.svg'
    }
  },
  {
    name: 'Even More',
    icon: {
      alt: 'Even More Benefits',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
    },
    link: {
      label: 'View All Your Benefits',
      url: '/us/en/skymiles/medallion-program/medallion-benefits'
    }
  }
];
